import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

const DevWelcome = () => {
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  return (
    <div className="bio text-right font-sm">
      {userInfo && (
        <button>
          <span>Hello {userInfo.email}, Welcome!</span>
          <span className="px-50 avatar d-inline-block py-25 rounded-circle ml-25 font-weight-bold font-sm">
            {userInfo.avatar}
          </span>
        </button>
      )}
    </div>
  );
};

export default DevWelcome;
